import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function VoiceTestimonial() {
  return <section className="w-full bg-warm-white py-16 px-6" data-id="element-77">
      <div className="max-w-2xl mx-auto" data-id="element-78">
        {/* Final CTA */}
        <motion.div id="cta-final" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center" data-id="element-79">
          <p className="font-lato text-medium-text text-base line-through mb-1" data-id="element-80">
            $17.800 ARS
          </p>
          <p className="font-playfair text-3xl md:text-4xl font-bold text-dark-text mb-2" data-id="element-81">
            $8.900 ARS
          </p>
          <p className="font-lato text-sm text-red-cta font-semibold mb-6" data-id="element-82">
            50% OFF — Solo por tiempo limitado
          </p>

          <motion.a href="https://vidaclave.online/cart/44836794269750:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block bg-red-cta text-white font-lato font-semibold text-base md:text-lg px-8 py-4 rounded-lg shadow-lg hover:bg-red-700 transition-colors duration-200" data-id="element-83">
            QUIERO RECUPERAR LA CALMA EN CASA
          </motion.a>
        </motion.div>

        {/* Garantía de 30 días */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="mt-12 mx-auto max-w-md border border-mint rounded-xl p-6 bg-mint-light/30 text-center" data-id="element-84">
          <ShieldCheck className="w-10 h-10 text-mint mx-auto mb-3" data-id="element-85" />
          <h3 className="font-playfair text-lg font-semibold text-dark-text mb-2" data-id="element-86">
            Garantía de 30 días
          </h3>
          <p className="font-lato text-sm text-medium-text leading-relaxed" data-id="element-87">
            Si dentro de los primeros 30 días sentís que este ebook no te ayudó,
            te devolvemos el 100% de tu dinero. Sin preguntas, sin vueltas. Tu
            tranquilidad es nuestra prioridad.
          </p>
        </motion.div>
      </div>
    </section>;
}